import {Injectable} from '@angular/core';
import {EdgeToEdge} from '@capawesome/capacitor-android-edge-to-edge-support';
import {Capacitor} from '@capacitor/core';

@Injectable({
    providedIn: 'root'
})
export class EdgeToEdgeService {
    public init(): Promise<void> {
        if (Capacitor.getPlatform() === 'android') {
            EdgeToEdge.getInsets().then(insets => {
                const safeTop = Math.min(insets.top, 48);
                document.documentElement.style.setProperty('--ion-safe-area-top', `${safeTop}px`);
            });
        }
        return this.setColor('medium');
    }

    public setColor(color: string): Promise<void> {
        if (Capacitor.getPlatform() !== 'android') {
            return Promise.resolve();
        }

        const cssColor = getComputedStyle(document.documentElement).getPropertyValue(`--ion-color-${color}`).trim();
        return EdgeToEdge.setBackgroundColor({
            color: cssColor
        });
    }
}
